// 날짜 문자열 'YYYY-MM-DD' (2026-10-14)
// toISOString() 은 세계 표준시(UTC) 기준이라, 한국 시간 00:00~08:59 에는 하루 전 날짜가 나옴
// → 매매일 기본값·오늘 일정·주간 달력 칸이 하루씩 밀리던 문제. 화면에서 날짜를 만들 때는 이 함수를 씀.
// (서버에서 받은 'YYYY-MM-DD' 문자열을 new Date() 로 바꿔 계산하는 곳은 UTC 끼리라 그대로 둬도 됨)
export function ymd(d = new Date()) {
  const x = d instanceof Date ? d : new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
}
